import React from 'react';
import {t} from 'ttag';
import Entry from '../entry/entry.jsx';
import {useSettingsContext} from '../../settings-context.js';

const Bitrix24 = () => {
  const {connectionConfig} = useSettingsContext();

  const openLine =
    connectionConfig.lines?.find(
      item => item.id === connectionConfig.line_id
    ) || {};

  return (
    <>
      <Entry
        label={t`Open line`}
        value={
          openLine.name === 'Add new line' ? t`Add a new line` : openLine.name
        }
      />
    </>
  );
};

export default Bitrix24;
